module.exports = __webpack_public_path__ + "img/ctrl-u2-dagger-stub-+.d18887bc.svg";